module.exports = __webpack_public_path__ + "ccb10829ffed8d450947d3e48ff475d9.fbx";